import { mdiPaperclip } from '@mdi/js'
import Icon from '@mdi/react'
import { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone'
import { Trans, useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Center } from '@/components/ui/center'
import { Flex } from '@/components/ui/flex'
import { Tooltip } from '@/components/ui/tooltip'
import { Text } from '@/components/ui/typography'

const DropZone = ({
    getRootProps,
    getInputProps,
    isUploading,
    isFullHeight,
}: {
    getRootProps: <T extends DropzoneRootProps>(props?: T) => T
    getInputProps: <T extends DropzoneInputProps>(props?: T) => T
    isUploading: boolean
    isFullHeight: boolean
}) => {
    const { t } = useTranslation()
    if (isUploading) {
        return null
    }

    const height = isFullHeight ? '100%' : '96px'

    const getTooltip = () => {
        return <Trans i18nKey={'documents.tooltip'} components={[<Text color="var(--chakra-colors-gray-500)" />, <Text maxW="180px" />]} />
    }

    return (
        <Box {...getRootProps()} height={height} mt="16px" cursor="pointer">
            <Center width="99%" height="100%" minH="96px" border="1px dashed">
                <input {...getInputProps()} />

                <Flex justifyContent="center" maxW="85%">
                    <Icon
                        path={mdiPaperclip}
                        size={1}
                        rotate={45}
                        style={{
                            marginTop: '8px',
                        }}
                    />
                    <Text textAlign="center" fontSize="14px" letterSpacing="0.25px" maxW="80%">
                        {t('documents.dropZoneText')}
                        <Tooltip
                            content={getTooltip()}
                            css={{
                                marginBottom: '-3px',
                                marginLeft: '8px',
                            }}
                        />
                    </Text>
                </Flex>
            </Center>
        </Box>
    )
}

export default DropZone
